export const buildOrderedStatusOptions = response => {
  const systemStatuses = response?.system_statuses || [];
  const customStatuses = (response?.custom_statuses || [])
    .slice()
    .sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  if (!systemStatuses.length) return customStatuses;

  return systemStatuses.flatMap(systemStatus => {
    const anchored = customStatuses.filter(
      custom => custom.anchor_system_stage === systemStatus.system_stage
    );
    return [systemStatus, ...anchored];
  });
};
